<template>
  <div id="audio" class="player-wrapper">
    <audio :loop="looping" ref="audio" :src="file" v-on:timeupdate="update" v-on:loadeddata="load" v-on:pause="playing = false" v-on:play="playing = true" preload="none"></audio>
    <div class="player">
      <div class="player-controls d-flex flex-row-reverse">
        <div id="play">
          <a v-on:click.prevent="playing = !playing" :title="playing ? 'Pause' : 'Play'" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                v-if="!playing"
                fill="currentColor"
                d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
              />
              <path
                v-else
                fill="currentColor"
                d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
              />
            </svg>
          </a>
        </div>
        <div id="seek" class="d-flex flex-row-reverse align-items-center">
          <div v-on:click="seek" class="player-progress" title="Seek">
            <div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
          </div>
          <div class="player-time">
            <div class="player-time-current">
              {{ this.currentSeconds | convertTimeHHMMSS }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: String,
      default: 'https://upload.wikimedia.org/wikipedia/commons/d/d6/Louis-Emmanuel_Jadin_-_Nocturne_No._3_in_G_minor_-_2._Allegro_molto.ogg',
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSeconds: 0,
      durationSeconds: 0,
      loaded: false,
      looping: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100,
    }
  },
  computed: {
    percentComplete() {
      return parseInt((this.currentSeconds / this.durationSeconds) * 100)
    },
  },
  filters: {
    convertTimeHHMMSS(val) {
      let hhmmss = new Date(val * 1000).toISOString().substr(11, 8)

      return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss
    },
  },
  watch: {
    playing(value) {
      if (value) {
        return this.$refs.audio.play()
      }
      this.$refs.audio.pause()
    },
  },
  methods: {
    load() {
      if (this.$refs.audio.readyState >= 2) {
        this.loaded = true
        this.durationSeconds = parseInt(this.$refs.audio.duration)

        return (this.playing = this.autoPlay)
      }

      throw new Error('Failed to load sound file.')
    },

    seek(e) {
      if (!this.loaded) return

      const el = e.target.getBoundingClientRect()
      const seekPos = (e.clientX - el.left) / el.width

      this.$refs.audio.currentTime = parseInt(this.$refs.audio.duration * seekPos)
    },

    update() {
      this.currentSeconds = parseInt(this.$refs.audio.currentTime)
    },
  },
  created() {
    this.looping = this.loop
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Nunito:400,700');
body {
  font-family: 'Nunito', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

.player {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 8px rgb(0 0 0 / 15%);
  color: #404040;
  display: inline-block;
  line-height: 1.5625;
  position: relative;
  padding: 0.2em 0.5em;
}

.player-controls {
  display: flex;
}

#seek {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;
  font-size: 12px;
}
.player-controls > div:last-child {
  border-right: none;
}
.player-controls > div a {
  color: #fff;
  display: block;
  text-decoration: none;
  height: 20px;
  width: 20px;
}
.player-controls > div a svg {
  display: inline-block;
  width: 0.9rem;
  margin: 1px 2px 0 15%;
}
#play {
  border-radius: 50px;
  background-color: #556ee6;
}
#play a {
  color: #fff;
}
.player-progress {
  background: rgba(85, 110, 230, 0.15);
  cursor: pointer;
  height: 13%;
  min-width: 200px;
  position: relative;
  border-radius: 5px;
  margin-left: 15px;
}
.player-progress .player-seeker {
  background-color: #556ee6;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  border-radius: 5px;
}

.player-time {
  display: flex;
  justify-content: space-between;
}
.player-time .player-time-current {
  font-weight: 700;
  min-width: 40px;
  padding-left: 10px;
}
.player-time .player-time-total {
  opacity: 0.5;
  padding-right: 5px;
}

.player-volume {
  display: inline-block;
  height: 1.1rem;
  margin: 0 0 0 2px;
  width: 6rem;
}
</style>
